import { j as l } from "./jsx-runtime-e6RZPHeG.js";
import { memo as c } from "react";
const i = ({
  title: e,
  titleId: o,
  ...s
}) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...s,
    children: [
      e ? /* @__PURE__ */ l.jsx("title", { id: o, children: e }) : null,
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M643.245 269.975c0 15.795-5.646 29.349-16.915 40.618s-24.503 16.915-39.75 16.915c-16.366 0-30.058-5.646-41.03-16.915-10.995-11.269-16.48-24.823-16.48-40.618 0-15.223 5.486-28.481 16.48-39.75 10.972-11.246 24.663-16.892 41.03-16.892 10.537 0 20.138 2.56 28.778 7.68 8.617 5.143 15.429 11.863 20.412 20.206s7.474 17.92 7.474 28.755zm-32.504 443.919c-11.406 25.463-29.258 51.521-53.578 78.15-24.275 26.652-54.721 39.955-91.317 39.955-24.595 0-43.041-6.08-55.339-18.218s-18.423-26.561-18.423-43.247c0-16.983 5.417-40.55 16.252-70.676l56.619-155.021c5.554-14.057 8.343-23.566 8.343-28.549 0-3.2-1.303-6.126-3.932-8.755-2.651-2.651-5.577-3.954-8.777-3.954-9.966 0-20.869 7.749-32.732 23.269-11.84 15.498-20.709 29.395-26.561 41.715h-38.63c17.258-38.652 39.727-68.573 67.407-89.808 27.658-21.212 55.247-31.841 82.745-31.841 19.338 0 35.361 4.777 48.07 14.286 12.755 9.509 19.109 22.172 19.109 37.967 0 16.709-3.2 33.532-9.646 50.493l-68.505 183.982c-4.686 12.595-7.017 22.835-7.017 30.744 0 3.52 1.371 6.972 4.16 10.309 2.789 3.383 5.783 5.074 9.006 5.074 8.8 0 17.852-4.686 27.224-14.08 9.372-9.349 21.075-26.629 35.132-51.796h40.39z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n = c(i);
export {
  n as default
};
